import React, { useState } from "react";

import { Carousel } from "react-responsive-carousel";
import { Modal } from "antd";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Card from "./Cards";

const Project = ({ project }) => {
  const [projDetails, setProjdetails] = useState(false);

  return (
    <div data-aos="fade-up" className="project_details">
      <Card className="portfolio__project">
        <div className="portfolio__project-image" data-aos="fade-right">
          <img src={project.image} alt="Portfolio Project" />
        </div>
        <h3>{project.title}</h3>
        <p>{project.desc}</p>
        <div className="portfolio__project-cta">
			{project.category.includes("Assessment") ? 
			<div >
            <a href="#contact" className="btn primary" >Contact us</a>
          </div>
			:
			<div className="btn primary" onClick={() => setProjdetails(true)}>
            + Details
          </div>
			}
         
        </div>
      </Card>

      <Modal
        title={project.title}
        className="modalStyle"
        centered
        open={projDetails}
        onCancel={() => setProjdetails(false)}
        footer={null}
        header={null}
        destroyOnClose={true}
      >
        <Carousel
          autoPlay={projDetails}
          infiniteLoop
          interval={1200}
          showArrows={false}
          showStatus={false}
        >
          {project.details &&
            project.details.map((det) => (
              <div key={det.inex}>
                <img src={det} className="project_slide" alt="projet_images" />
              </div>
            ))}
        </Carousel>
      </Modal>
    </div>
  );
};

export default Project;
